// extracted by mini-css-extract-plugin
module.exports = {"cards":"index_cards__37bc5","card":"index_card__1nD_T"};